// extracted by mini-css-extract-plugin
module.exports = {"Switch":"SliderToggle_Switch__3rybQ","RoundSlider":"SliderToggle_RoundSlider__2WLLx","Checked":"SliderToggle_Checked__Lno_B"};